// extracted by mini-css-extract-plugin
export default {"plugContainer":"Plug_plugContainer__9SLBG","backButtonWrapper":"Plug_backButtonWrapper__kkTrw","title":"Plug_title__3TD4f","subtitle":"Plug_subtitle__PbbFC"};